import React, { useContext, useEffect, useState, useRef } from 'react';

import { useHistory } from 'react-router-dom';

import expoHallAPI from '../api/expoHallAPI';
import { setColor } from '../styles/styles';

import { connectChat, disconnectChat } from '../api/expoHallSocket';

import ExhibitorContext from '../context/exhibitorContext';
import Navbar from '../components/globals/Navbar';
import { Context as UserContext } from '../context/UserContext';

import styled from 'styled-components';
import SliderCarousel from '../components/sliderCarousel/SliderCarousel';
import ReactPlayer from 'react-player';
import { Context as AttendantContext } from '../context/AttendantContext';
import { Context as SocketContext } from '../context/SocketContext';
import Countdown from 'react-countdown';
import { CustomNotification } from '../components/globals/NotificationAgreement';
import SliderPageRightPane from './SliderPageRightPane';
import LoadingPage from './LoadingPage';
import { Tooltip } from '@material-ui/core';
import SiteData from '../config';

//timestamp logging
import getTimeLogged from '../utils/getTimeLogged';
import { set } from 'lodash';
import { date } from 'date-fns/locale/af';

const SliderPage = ({ className, loadChat }) => {
  const exhibitors = useContext(ExhibitorContext);
  const {
    state,
    state: { user },
    setUser,
  } = useContext(UserContext);
  const { setAttendant } = useContext(AttendantContext);
  const {
    state: { categories, connection, isTileClicked, EventisLive, isPaused },
    setCategories,
    setTileStatus,
    setEventisLive,
    setIsPaused,
  } = useContext(SocketContext);

  const [openNotification, setOpenNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({});
  const [loadCategories, setLoadCategories] = useState(false);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    handleAuthCheck();
  }, []);

  // useEffect(() => {
  //   return () => {
  //     if (user) {
  //       disconnectChat(user, SiteData.generalChatId);
  //     }
  //   };
  // }, [user]);

  useEffect(() => {
    if (user) {
      handleGetCategories();
      getNotification();
    }
  }, [connection, user]);

  // useEffect(() => {
  //   if (user && connection) {
  //     connectChat(user, SiteData.generalChatId);
  //   }
  // }, [connection, user]);

  const handleAuthCheck = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-user');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendee/profile/');
      if (data) {
        setUser(data);
      }
    } catch (error) {
      handleAuthCheckAttendant();
    }
  };

  const handleAuthCheckAttendant = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendant/profile/');
      if (data) {
        setUser(data);
        setAttendant(data);
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-user');
      localStorage.removeItem('shrm-li-expo-attendant');
      history.push('/login');
      setUser(undefined);
      setAttendant(undefined);
    }
  };

  const handleGetCategories = async () => {
    try {
      const { data } = await expoHallAPI.get('/api/categories/');
      setCategories(data);
      setLoadCategories(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getNotification = async () => {
    try {
      const { data } = await expoHallAPI.get('/api/notifications/expo/');
      data.map((eachData) => {
        timeTriggerActions(eachData);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const timeTriggerNow = (data) => {
    const now = new Date();
    const TimeNow = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const EventTime = parseFloat(data.milliseconds);
    //time left for event
    let TimeLeftForEvent = EventTime - TimeNow;
    if (TimeLeftForEvent < 0) {
      TimeLeftForEvent += 86400000; // adds 1 day (runs everyday)
    }

    const eventDay = new Date(EventTime).getUTCDate();
    if (now.getUTCDate() === eventDay) {
      setTimeout(() => {
        auditoriumActions(data);
      }, TimeLeftForEvent);
    }
  };

  const timeTriggerPeriod = (data) => {
    const now = new Date();
    const EventTime = new Date(data.time);
    const EventEndTime = new Date(data.end_time);
    if (
      new Date(now.toUTCString()) > new Date(EventTime.toUTCString()) &&
      new Date(now.toUTCString()) < new Date(EventEndTime.toUTCString())
    ) {
      auditoriumActions(data);
    }
  };

  const timeTriggerActions = (data) => {
    switch (data.notif_type) {
      case 'NOW':
        timeTriggerNow(data);
        break;
      case 'PERIOD':
        timeTriggerPeriod(data);
        break;
      default:
      // code block
    }
  };

  const auditoriumActions = (data) => {
    const now = new Date(new Date().toUTCString());
    const EventTime = new Date(new Date(data.time).toUTCString());
    const EventEndTime = new Date(new Date(data.end_time).toUTCString());
    const differenceAfter = now.getTime() - EventTime.getTime();
    const differenceBefore = EventEndTime.getTime() - now.getTime();
    const minutes = Math.ceil(differenceBefore / 60000);
    
    getTimeLogged(data.id.toString());
    switch (data.action) {
        case 'linkNotification':
          setOpenNotification(true);
          data.buttonText = 'Click Here';
          data.time = '';
          setNotificationData(data);
          setTimeout(() => {
            setOpenNotification(false);
          }, 50000);
          break;
        case 'textNotification':
          setOpenNotification(true);
          data.buttonText = '';
          data.time = '';
          setNotificationData(data);
          setTimeout(() => {
            setOpenNotification(false);
          }, 50000);
          break;
        case 'movePages':
          setNotificationData(data);
          if (SiteData.isMultipleAuditorium) {
            proceedToMultAuditorium(data?.auditorium);
          }else{
            proceedToAuditorium();
          }
          
          break;
        case 'eventIsLive':
          // when Live event is on going with the join to go back to the expohall
          // While live event is going on if you return to the expor hall.
          setNotificationData(data);
          setOpenNotification(true);
          data.buttonText = '';
          data.time = '';
          setEventisLive(true);
          setTimeout(() => {
            setEventisLive(false);
          }, differenceBefore);

          break;
      }
    };
  const proceedToZoomLink = (link) => {
    window.open(link);
  };
  const proceedToAuditorium = () => {
    if (SiteData.isMultipleAuditorium) {
      history.push(`/auditorium/${notificationData.auditorium}`);
            
    }else{
      history.push('/auditorium');
    }
  };

  const proceedToMultAuditorium = (aud) => {
     history.push(`/auditorium/${aud}`);
  };
  // if (!loadChat || !loadCategories) {
  //   return <LoadingPage />;
  // } else {
  return (
    <div className={className}>
      <CustomNotification
        onButtonClick={(e) =>
          notificationData.buttonText === 'Click Here'
            ? proceedToZoomLink(notificationData.external_link)
            : proceedToAuditorium()
        }
        title={notificationData.title}
        buttonText={notificationData.buttonText}
        description={notificationData.message}
        time={notificationData.time}
        open={openNotification}
        onCloseIconClick={(e) => {
          setOpenNotification(false);
        }}
      />
      <div className="leftPane">
        <Navbar />

        {SiteData.Isbanner && (
          <BannerDiv background={SiteData.bannerData.backgroundURL}>
            {SiteData.bannerData.videoURL && (
              <VideoContainer>
                <ReactPlayer
                  config={{
                    file: { attributes: { controlsList: 'nodownload' } },
                  }}
                  playing={isTileClicked}
                  url={SiteData.bannerData.videoURL}
                  loop
                  onPause={() => {
                    if (isTileClicked) {
                      setIsPaused(true);
                    } else setIsPaused(false);
                  }}
                  onPlay={() => {
                    if (!isTileClicked) {
                      setTileStatus(true);
                    }
                  }}
                  controls
                  volume={0.3}
                  muted
                  width="100%"
                  height="100%"
                />
              </VideoContainer>
            )}
            {/* <FadeEffect /> */}
          </BannerDiv>
        )}
        <ContainerDiv isbanner={SiteData.Isbanner}>
          {/* <p>NOTE: If tiles do not appear, please resize your browser window</p> */}
          {EventisLive && (
            <Tooltip
              title={
                <h6
                  style={{
                    color: 'white',
                    display: 'flex',
                    paddingTop: '0.5rem',
                  }}
                >
                  Session is Live
                </h6>
              }
            >
              <LivePulse
                onClick={() => {
                  proceedToAuditorium();
                }}
              />
            </Tooltip>
          )}
          {!!categories &&
            categories
              .sort((a, b) => a.id - b.id)
              .map((category) => (
                <SliderCarousel key={category.id} category={category} />
              ))}
        </ContainerDiv>
      </div>
      <div className="rightPane">
        <h6>Event Discussion</h6>
        <SliderPageRightPane />
      </div>
    </div>
  );
  // }
};

export default styled(SliderPage)`
  display: flex;
  position: relative;
  .leftPane {
    flex: 0.76;
    overflow-x: hidden;
    width: 76%;
  }
  .rightPane {
    flex: 0.24;
    height: 100vh;
    position: fixed;
    width: 24%;
    right: 0;
    background-color: white;
    overflow: hidden;
    h6 {
      padding-top: 5px;
      text-align: center;
      background-color: ${setColor.mainGrey};
      padding-bottom: 1rem;
      margin-bottom: 0;
    }
  }
`;

const ContainerDiv = styled.div`
  margin-right: 2rem;
  p {
    text-align: center;
  }
  margin-top: ${(props) => (props.isbanner ? '1rem' : '7rem')};
`;

const BannerDiv = styled.div.attrs({})`
  background-image: url(${(props) => props.background});
  height: 80vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  // margin-top: 7rem;
  /* margin-bottom: -3rem; */
  position: relative;
`;
// const BannerDiv = styled.div.attrs({})`
//   background-image: linear-gradient(
//       180deg,
//       rgba(0, 0, 0, 0) 52%,
//       rgba(0, 0, 0, 0.7) 90%,
//       rgb(28 28 28) 100%
//     ),
//     url(${(props) => props.background});
//   min-height: 40rem;
//   //height: 80vh;
//   background-repeat: no-repeat;
//   // background-position: 0 100px;
//   background-position: 0px;
//   background-size: cover;
//   /* margin-bottom: -3rem; */
//   position: relative;
// `;
const FadeEffect = styled.div`
  height: 25vh;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    #00000000,
    #000000b8,
    #00000082,
    #00000012
  );
  /* background: red; */
  /* margin-top: -25rem; */
  position: absolute;
  bottom: 0;
`;

const VideoContainer = styled.div`
  width: 45vw;
  position: absolute;
  right: 7%;
  top: 20%;
  :focus {
    outline: none;
  }
`;

export const LivePulse = styled.div`
  background: red;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  margin: 10px;
  height: 30px;
  width: 30px;
  transform: scale(1);
  animation: pulse 2s infinite;
  right: 25%;
  position: fixed;
  cursor: pointer;
  z-index: 1;
  top: 10%;
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
    }
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
    }
  }
`;